import styled from 'styled-components';


 

export const Container = styled.div` 
  padding-top:0.5em;
  width: 95%; 
  height: 3em; 
  display:flex;
  flex-direction:row;
`;
export const FormTitleContainer=styled.div`
width:8vm;
`;
export const FormTitle=styled.div`
color: #000;
font-family: Product Sans;
font-size: 1.5em;
font-style: normal;
font-weight: 700;
line-height: normal;
width: 150px;
`;
export const ConnectivityContainer=styled.div`
margin-left:2vh;
width: 9em;

height: 22px;
flex-shrink: 0;
border-radius: 10px;
background-color: var(--color-whitesmoke-100);
display:flex;
flex-direction:row;

`;
export const ConnectivityIcon=styled.img`
overflow-clip-margin: content-box; 
padding-left: 12px;
    width: 16px;
    height: 16x;
    overflow: hidden;
}
`;

export const ConnectivityStatus=styled.div`
padding-top: 5px;
padding-left: 6px;
    font-size: var(--font-size-3xs);
    color: var(--color-gray-100);
`;
export const Connected=styled.div`
margin-top: 9px;
margin-left: 5px;
    border-radius: 50%;
    background-color: var(--color-forestgreen-100);
    width: 5px;
    height: 5px;
`;

export const ProfileContainer=styled.div`  
width:100%;  
`;
export const ProfileBox=styled.div`  

float:right;
border-radius: 21px;
background: #F9F9F9;  
padding:10px 10px 5px 20px; 
cursor:pointer;
`; 
export const Box=styled.div`  
width:100%;  
display:flex;
flex-direction:row;
cursor:pointer;

`;
export const ProfileName=styled.div`  
margin-top:5px;
margin-right:5px;
margin-left:5px;
color: #000;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
cursor:pointer;

`;  
export const DownArrow=styled.img`   
margin-top:10px;
margin-left:10px;
margin-right:10px;
width: 10.95px;
height: 10px;
cursor:pointer;
`;
export const Avatar=styled.img`   
width: 30px;
height: 30px;

`;
    

